import React from 'react';
import { Box, Chip, Typography } from '@mui/material';
import SectionCard from '../../component/ui/SectionCard';

const WidgetCard = ({ title, subtitle, badge, action, children, minHeight = 320, sx }) => {
  return (
    <SectionCard
      title={
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, minWidth: 0 }}>
          <Typography variant="subtitle1" sx={{ fontWeight: 950, lineHeight: 1.1 }}>
            {title}
          </Typography>
          {badge ? (
            <Chip
              size="small"
              label={badge}
              sx={{ borderRadius: 999, fontWeight: 900, height: 22 }}
              variant="outlined"
            />
          ) : null}
        </Box>
      }
      subtitle={subtitle}
      action={action}
      sx={{ height: '100%', ...sx }}
      contentSx={{ pt: 1.25, minHeight, display: 'flex', flexDirection: 'column' }}
    >
      {children}
    </SectionCard>
  );
};

export default WidgetCard;

